module.exports = "label {\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n/* For Firefox */\n\ninput[type='number'] {\n  -moz-appearance: textfield; }\n\n/* Webkit browsers like Safari and Chrome */\n\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/input/cbm-input-text/cbm-input-text.component.scss
// module id = ./src/app/shared/input/cbm-input-text/cbm-input-text.component.scss
// module chunks = main